<template>
  <v-dialog
    v-model="dialog"
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar
        dark
        color="primary"
      >
        <v-toolbar-title>{{ title }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <center>
          <slot></slot>
          <div class="pb-5">
            <v-btn
              class="mr-5"
              @click="handleConfirm"
            >
              <span style="color:red">Remove</span>
            </v-btn>
            <v-btn
              @click="dialog = false"
            >
              Back
            </v-btn>
          </div>
        </center>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script setup>
import { ref, onMounted, computed, watch, toRefs } from 'vue'
import { formatTime, formatDate, loading } from '@/utils/helper'

const props = defineProps({
  value: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: 'Remove Training Item',
  },
})
const { value, bookingInfoProp } = toRefs(props)

const dialog = ref(value.value)

const emits = defineEmits(['input', 'closed', 'confirm'])
watch(dialog, val => {
  console.log('diaryDialog', val)
  emits('input', val)
})

watch(value, val => {
  console.log('value', val)
  dialog.value = val
})

onMounted(() => {
  dialog.value = value.value
})

function handleConfirm() {
  emits('confirm')
}
</script>
